import React, { useEffect, useState, useCallback } from "react";
// import Header from "../layout/Header";
// import Sidebar from "../layout/Sidebar";
import axios from "axios";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { baseUrl } from "../../config/baseUrl";
// import { ToastMessgae } from "../utils/toast";
import Swal from "sweetalert2";
import Pagination from "../Pagination/Pagination";
import { ToastMessgae } from "../utils/toast";
import { REPORT_COLOR_ENCODING } from "../../config/colorEncoding";

export default function ReportList() {
  let [reportData, setReportData] = useState([]);
  // let [reportDatafilter, setReportDataFilter] = useState([]);
  let [onLoader, setOnLoader] = useState(true);
  let [exportLoader, setExportLoader] = useState(false);
  // let [filterDate, setFilterDate] = useState("");
  // let [pageNumber, setPageNumber] = useState(1);
  let [pageLimit, setPageLimit] = useState(1);
  let Navigate = useNavigate();
  let [depoData, setDepoData] = useState([]);
  let [companyNameData, setCompanyNameData] = useState([]);
  let loginUser = JSON.parse(localStorage.getItem("user"));
  const location = useLocation();
  const data = location.state;

  const [paginationDetails, setPaginationDetails] = useState({});
  let [pageNumber, setPageNumber] = useState(data ? data.pageNumber : 1);
  let [searchData, setSearchData] = useState(
    data
      ? data.searchData
      : {
          company: "",
          depo: "",
          start_date: "",
          end_date: "",
          cleaning_type: "",
          bus_number: "",
          issue_type: "",
        }
  );

  // Add this function
  const handleDownloadReport = async () => {
    // if not any filter selected, then show alert
    if (
      !searchData?.company &&
      !searchData?.depo &&
      !searchData?.start_date &&
      !searchData?.end_date &&
      !searchData?.cleaning_type &&
      !searchData?.bus_number &&
      !searchData?.issue_type
    ) {
      // ToastMessgae({
      //   code: 400,
      //   message: "Please select at least one filter to download the report.",
      // });
      // return;
    }
    if (!searchData?.start_date) {
      setStartDateError("Please select start date.")
      return
    }

    if (!searchData?.end_date) {
      setEndDateError("Please select end date.")
      return
    }

    setExportLoader(true);
    try {
      const params = new URLSearchParams();

      // Add search filters as query parameters
      if (searchData?.company) params.append("company", searchData.company);
      if (searchData?.depo) params.append("depo", searchData.depo);
      if (searchData?.start_date)
        params.append("start_date", searchData.start_date);
      if (searchData?.end_date) params.append("end_date", searchData.end_date);
      if (searchData?.cleaning_type)
        params.append("cleaning_type", searchData.cleaning_type);
      if (searchData?.bus_number)
        params.append("bus_number", searchData.bus_number);
      if (searchData?.issue_type) {
        // Handle issue_type mapping same as in reportListApi
        if (searchData.issue_type === "issue") {
          params.append("issue_type", "issue");
        } else if (searchData.issue_type === "graffiti") {
          params.append("issue_type", "has_graffiti_images");
        } else if (searchData.issue_type === "damage") {
          params.append("issue_type", "has_damage_images");
        } else if (searchData.issue_type === "other_issue") {
          params.append("issue_type", "has_other_images");
        } else if (searchData.issue_type === "emergency") {
          params.append("issue_type", "emergency");
        }
      }

      const url = params.toString()
        ? `${baseUrl}/module/admin/download-report-excel?${params.toString()}`
        : `${baseUrl}/module/admin/download-report-excel`;

      const response = await axios.get(url, {
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
        responseType: "blob",
      });

      // Create a blob from the response
      const blob = new Blob([response.data], {
        type:
          response.headers["content-type"] ||
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Create a temporary URL and trigger download
      const urlObject = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = urlObject;
      link.setAttribute("download", `report_export.xlsx`);
      document.body.appendChild(link);
      link.click();

      // Clean up
      link.remove();
      window.URL.revokeObjectURL(urlObject);
    } catch (error) {
      console.error("Error downloading report:", error);
      alert("Failed to download report. Please try again.");
    } finally {
      setExportLoader(false);
    }
  };



  const reportListApi = useCallback(
    async (currentSearchData = searchData, currentPageNumber = pageNumber) => {
      if ((currentSearchData?.start_date && !currentSearchData?.end_date) || (!currentSearchData?.start_date && currentSearchData?.end_date)) {
        ToastMessgae({
          code: 400,
          message: "Please select both start date and end date together, or leave both empty.",
        });
        return;
      }
      setOnLoader(true);
      try {
        const qs = new URLSearchParams();
        qs.set("page", currentPageNumber);
        if (currentSearchData?.company)
          qs.set("company", currentSearchData.company);
        if (currentSearchData?.depo) qs.set("depo", currentSearchData.depo);
        if (currentSearchData?.start_date)
          qs.set("start_date", currentSearchData.start_date);
        if (currentSearchData?.end_date)
          qs.set("end_date", currentSearchData.end_date);
        if (currentSearchData?.cleaning_type)
          qs.set("cleaning_type", currentSearchData.cleaning_type);
        if (currentSearchData?.bus_number)
          qs.set("bus_number", currentSearchData.bus_number);
        if (currentSearchData?.issue_type === "issue") {
          qs.set("issue_type", "issue");
        } else if (currentSearchData?.issue_type === "graffiti") {
          qs.set("issue_type", "has_graffiti_images");
        } else if (currentSearchData?.issue_type === "damage") {
          qs.set("issue_type", "has_damage_images");
        } else if (currentSearchData?.issue_type === "other_issue") {
          qs.set("issue_type", "has_other_images");
        } else if (currentSearchData?.issue_type === "emergency") {
          qs.set("issue_type", "emergency");
        }

        let response = await axios(
          `${baseUrl}/module/mobile/report-viewset?${qs.toString()}`,
          {
            method: "GET",
            headers: {
              Authorization: "Token " + localStorage.getItem("token"),
            },
          }
        );
        if (response.data.code === 500) {
          ToastMessgae({
            code: response.data.code,
            message:
              response.data.message ||
              "An error occurred while creating the report.",
          });
          setOnLoader(false);
          return;
        }
        if (response.data.code === 404) {
          if (currentPageNumber > 1) {
            setPageNumber(currentPageNumber - 1);
            setOnLoader(false);
            return alert("page not field");
          }
          setReportData([]);
          setPaginationDetails({});
          setPageLimit(0);
          setOnLoader(false);
          return;
        }
        setReportData(response?.data?.data || []);
        setPaginationDetails(response?.data?.extra);
        setPageLimit(response.data.extra.total);
        setOnLoader(false);
      } catch (error) {
        if (error.response?.data?.code === 500) {
          ToastMessgae({
            code: error.response.data.code,
            message:
              error.response.data.message ||
              "An error occurred while creating the report.",
          });
        } else {
          alert(error.message + ", Some error form sever");
        }
        setOnLoader(false);
        Navigate("/");
      }
    },
    [pageNumber, Navigate]
  );
  useEffect(() => {
    reportListApi(searchData, pageNumber);
  }, [pageNumber]);

  const getCleaningTypeColor = (report) => {
    const colors = [];

    if (report?.graffiti_images === true) {
      colors.push(REPORT_COLOR_ENCODING.GRAFFITI);
    }

    if (
      report?.issues &&
      Array.isArray(report.issues) &&
      report.issues.length > 0
    ) {
      colors.push(REPORT_COLOR_ENCODING.ISSUE_IMAGE);
    }

    if (report?.other_images === true) {
      colors.push(REPORT_COLOR_ENCODING.OTHER_ISSUE);
    }

    if (report?.damage_images === true) {
      colors.push(REPORT_COLOR_ENCODING.DAMAGE);
    }

    if (report?.emergency === true) {
      colors.push(REPORT_COLOR_ENCODING.EMERGENCY);
    }

    if (colors.length === 0) {
      return null;
    } else if (colors.length === 1) {
      return colors[0];
    } else {
      return colors;
    }
  };

  // Function to generate stripe background style
  const getStripeStyle = (colors) => {
    if (!colors || colors.length === 0) return {};
    if (colors.length === 1) {
      return { backgroundColor: colors };
    }

    // Create linear gradient for stripes
    const percentage = 100 / colors.length;
    const gradientStops = colors
      .map((color, index) => {
        const start = index * percentage;
        const end = (index + 1) * percentage;
        return `${color} ${start}%, ${color} ${end}%`;
      })
      .join(", ");

    return {
      background: `linear-gradient(to right, ${gradientStops})`,
      backgroundSize: "100% 100%",
    };
  };

  let deleteHandle = (id) => {
    let apiCall = async () => {
      let response = await axios(
        `${baseUrl}/module/mobile/report-viewset/${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: "Token " + localStorage.getItem("token"),
          },
        }
      );

      setReportData((prvVal) => {
        prvVal = prvVal.filter((arr) => arr.id !== response?.data?.data?.id);
        return [...prvVal];
      });
      reportListApi();
    };
    Swal.fire({
      title: "Are you sure..?",
      text: `You won't be able to revert this..!`,
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, delete it!`,
    }).then((result) => {
      if (result.isConfirmed) {
        apiCall();
        Swal.fire({
          title: "deleted...!",
          text: `Report has been delete..`,
          icon: "success",
        });
      }
    });
  };

  const depo = useCallback(
    async (companyId = null) => {
      try {
        let url = `${baseUrl}/module/admin/depo-list`;

        // For SUPER_ADMIN, if company is selected, filter depo list by company
        if (loginUser?.user_type === "SUPER_ADMIN" && companyId) {
          url += `?company=${companyId}`;
        }

        const response = await axios(url, {
          method: "GET",
          headers: {
            Authorization: "Token " + localStorage.getItem("token"),
          },
        });
        setDepoData(response?.data?.data || []);
      } catch (error) {
        console.error("depo fetch error:", error);
        setDepoData([]);
      }
    },
    [loginUser?.user_type]
  );

  // Update the initial useEffect
  useEffect(() => {
    // For SUPER_ADMIN: only fetch depo list if company is selected
    // For other users: fetch depo list normally
    if (loginUser?.user_type === "SUPER_ADMIN") {
      companyName();
      // Only fetch depo list if company is selected
      if (searchData.company) {
        depo(searchData.company);
      } else {
        setDepoData([]); // Clear depo list when no company selected
      }
    } else {
      depo();
      companyName();
    }
  }, []);

  // For SUPER_ADMIN: Fetch depo list when company changes
  useEffect(() => {
    if (loginUser?.user_type === "SUPER_ADMIN") {
      if (searchData.company) {
        depo(searchData.company);
        // Clear depo selection when company changes
        setSearchData((curr) => ({ ...curr, depo: "" }));
      } else {
        setDepoData([]);
        setSearchData((curr) => ({ ...curr, depo: "" }));
      }
    }
  }, [searchData.company, depo, loginUser?.user_type]);

  // depo();
  const companyName = async () => {
    let response = await axios(
      // https://admin.cleaningcrm.fluttertrends.com/module/admin/company-list
      `${baseUrl}/module/admin/company-list`,
      {
        method: "GET",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
      }
    );
    setCompanyNameData(response.data?.data);
  };

  useEffect(() => {
    depo();
    companyName();
  }, []);

  let filterHandler = async (e) => {
    const { name, value, type } = e.target;

    // Handle fields normally
    setSearchData((curr) => {
      // Handle text inputs - trim leading spaces
      if (type === "text" && typeof value === "string") {
        return { ...curr, [name]: value.replace(/^\s+/, "") };
      }
      return { ...curr, [name]: value };
    });
  };


  // Reset filter function
  const handleReset = async () => {
    const resetSearchData = {
      company: "",
      depo: "",
      start_date: "",
      end_date: "",
      cleaning_type: "",
      bus_number: "",
      issue_type: "",
    };
    setSearchData(resetSearchData);
    setPageNumber(1);
    // Call API with reset filters
    reportListApi(resetSearchData, 1);
  };

  // replace your handleSearch with this version
  let handleSearch = async (e) => {

    e.preventDefault();
    setPageNumber(1);
    // Call API with current search data and page 1
    reportListApi(searchData, 1);
  };

  const [startDateError, setStartDateError] = useState("")
  const [endDateError, setEndDateError] = useState("")

  const [viewType, setViewType] = useState("view");
  useEffect(() => {
    setStartDateError("")
    setEndDateError("")
  }, [searchData.start_date, searchData.end_date, viewType])

  const handleViewType = (e) => {
    setViewType(e.target.value);
  };

  return (
    <>
      <style>
        {`
          #emergencyCheck {
            appearance: none;
            -webkit-appearance: none;
            -moz-appearance: none;
            width: 20px !important;
            height: 20px !important;
            border: 2px solid #fff !important;
            border-radius: 3px;
            background-color: #fff !important;
            cursor: pointer;
            position: relative;
          }
          #emergencyCheck:checked {
            background-color: #fff !important;
            border-color: #fff !important;
          }
          #emergencyCheck:checked::after {
            content: '';
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 12px;
            height: 12px;
            background-color: #e74c3c;
            border-radius: 2px;
          }
          #emergencyCheck:checked::before {
            content: '✓';
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            color: #fff;
            font-size: 14px;
            font-weight: bold;
            z-index: 1;
          }
        `}
      </style>
      <section className="main-sec">
        <div className="row">
          <div className="col-lg-12">
            <div className="dashboard-title">
              <h4 className="dash-head">
                <i className="fa fa-flag me-2" />
                Report List
              </h4>
            </div>
            <div className="custom-bredcump">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Report
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="cards bus-list">
              <div className="bus-filter">
                <div className="row justify-content-end">
                  <div className="col-lg-12">
                    <div className="row justify-content-end mb-3">
                      <div className="col">
                        <label>View Type</label>
                        <select
                          name="view_type"
                          onChange={handleViewType}
                          className="form-select"
                          value={searchData.view_type}
                        >
                          {/* View or download csv */}
                          <option value="">Select View Type</option>
                          <option value="view">View</option>
                          <option value="csv">Download CSV</option>
                        </select>
                      </div>

                      {loginUser.user_type === "SUPER_ADMIN" && (
                        <div className="col ">
                          <label>Company</label>
                          <select
                            name="company"
                            value={searchData.company}
                            onChange={filterHandler}
                            className="form-select"
                          >
                            <option value="">Select Company</option>
                            {companyNameData?.map((arr) => (
                              <option value={arr?.id} key={arr?.id}>
                                {arr?.company_name}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}
                      <div className="col ">
                        <label>Depot</label>
                        <select
                          name="depo"
                          onChange={filterHandler}
                          className="form-select"
                          value={searchData.depo}
                          disabled={
                            loginUser?.user_type === "SUPER_ADMIN" &&
                            !searchData.company
                          }
                        >
                          <option value="">
                            {loginUser?.user_type === "SUPER_ADMIN" &&
                            !searchData.company
                              ? "Select Company First"
                              : "Select Depot"}
                          </option>
                          {depoData?.map((arr) => (
                            <option key={arr?.id} value={arr?.id}>
                              {arr?.depo_name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col">
                        <label>Cleaning Type</label>
                        <select
                          name="cleaning_type"
                          onChange={filterHandler}
                          className="form-select"
                          value={searchData.cleaning_type}
                          disabled={
                            loginUser?.user_type &&
                            loginUser?.user_type === "SUPER_ADMIN" &&
                            viewType === "csv" &&
                            !searchData.company
                          }
                        >
                          <option value="">
                            {loginUser?.user_type &&
                            loginUser?.user_type === "SUPER_ADMIN" &&
                            viewType === "csv" &&
                            !searchData.company
                              ? "Select Company First"
                              : "Select Cleaning Type"}
                          </option>
                          <option value="REGULAR_CLEANING">
                            Regular Cleaning
                          </option>
                          <option value="STANDARD_DEEP_CLEANING">
                            Standard Deep Cleaning
                          </option>
                          <option value="ANNUAL_DEEP_CLEANING">
                            Annual Deep Cleaning
                          </option>
                        </select>
                      </div>
                      <div className="col">
                        <label>Issue Type</label>
                        <select
                          name="issue_type"
                          onChange={filterHandler}
                          className="form-select"
                          value={searchData.issue_type}
                          disabled={
                            loginUser?.user_type &&
                            loginUser?.user_type === "SUPER_ADMIN" &&
                            viewType === "csv" &&
                            !searchData.company
                          }
                        >
                          <option value="">
                            {loginUser?.user_type &&
                            loginUser?.user_type === "SUPER_ADMIN" &&
                            viewType === "csv" &&
                            !searchData.company
                              ? "Select Company First"
                              : "Select Issue Type"}
                          </option>
                          <option value="issue">Lost Property</option>
                          <option value="graffiti">Graffiti</option>
                          <option value="damage">Damage</option>
                          <option value="other_issue">Other Issue</option>
                          <option value="emergency">
                            Emergency button pushed
                          </option>
                        </select>
                      </div>
                      <div className="col">
                        <label>Bus number</label>
                        <input
                          type="text"
                          name="bus_number"
                          className="form-control"
                          placeholder="Bus Number"
                          onChange={filterHandler}
                          value={searchData.bus_number}
                        />
                      </div>
                    </div>
                    {/* Second Row: start_date, end_date, submit button */}
                    <div className="row justify-content-end">
                      <div className="col">
                        <label htmlFor="start_date" className="form-label">
                          Start Date
                        </label>
                        <input
                          type="date"
                          name="start_date"
                          className="form-control"
                          onChange={filterHandler}
                          value={searchData.start_date}
                        />
                        {startDateError && (<p className="text-red text-sm" style={{color: "red", textAlign: "left", paddingLeft: "4px" }}>
                          {startDateError}*
                        </p>) }
                      </div>
                      <div className="col">
                        <label htmlFor="end_date" className="form-label">
                          End Date
                        </label>
                        <input
                          type="date"
                          name="end_date"
                          className="form-control"
                          onChange={filterHandler}
                          value={searchData.end_date}
                        />
                        {endDateError && (<p className="text-red text-sm" style={{color: "red", textAlign: "left", paddingLeft: "4px" }}>
                          {endDateError}*
                        </p>) }
                      </div>
                      {viewType === "view" && (
                        <div className="col ">
                          <label htmlFor="submit" className="form-label">
                            &nbsp;
                          </label>
                          <button
                            className="thm-btn w-100"
                            onClick={handleSearch}
                          >
                            Submit
                          </button>
                        </div>
                      )}
                      {viewType === "csv" && (
                        <div className="col">
                          <label htmlFor="download" className="form-label">
                            &nbsp;
                          </label>
                          {/* disbale button if exportLoader is true and add small spinner */}
                          <button
                            disabled={exportLoader}
                            className={`thm-btn text-white bg-dark border-dark w-100  ${
                              exportLoader ? "disabled" : ""
                            }`}
                            style={{
                              opacity: exportLoader ? 0.7 : 1,
                              cursor: exportLoader ? "not-allowed" : "pointer",
                            }}
                            onClick={handleDownloadReport}
                            type="button"
                          >
                            {exportLoader ? (
                              <>
                                <i className="fa fa-spinner fa-spin me-2"></i>{" "}
                                Downloading...
                              </>
                            ) : (
                              <>
                                <i className="fa fa-download me-2"></i> Download
                                CSV
                              </>
                            )}
                          </button>
                        </div>
                      )}
                        <div className="col ">
                          <label htmlFor="submit" className="form-label">
                            &nbsp;
                          </label>
                          <button
                            className="thm-btn w-100"
                            onClick={handleReset}
                          >
                            Reset
                          </button>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Color Encoding Legend */}
              <div className="mt-3 mb-3">
                <div className="d-flex align-items-center flex-wrap gap-3">
                  <span className="fw-bold me-2">Color Encoding:</span>
                  <div className="d-flex align-items-center">
                    <span
                      className="legend-color"
                      style={{
                        width: "20px",
                        height: "20px",
                        backgroundColor: REPORT_COLOR_ENCODING.GRAFFITI,
                        borderRadius: "4px",
                        display: "inline-block",
                        marginRight: "8px",
                      }}
                    />
                    <span>Graffiti</span>
                  </div>
                  <div className="d-flex align-items-center">
                    <span
                      className="legend-color"
                      style={{
                        width: "20px",
                        height: "20px",
                        backgroundColor: REPORT_COLOR_ENCODING.ISSUE_IMAGE,
                        borderRadius: "4px",
                        display: "inline-block",
                        marginRight: "8px",
                      }}
                    />
                    <span>Lost Property</span>
                  </div>
                  <div className="d-flex align-items-center">
                    <span
                      className="legend-color"
                      style={{
                        width: "20px",
                        height: "20px",
                        backgroundColor: REPORT_COLOR_ENCODING.OTHER_ISSUE,
                        borderRadius: "4px",
                        display: "inline-block",
                        marginRight: "8px",
                      }}
                    />
                    <span>Other Issue</span>
                  </div>
                  <div className="d-flex align-items-center">
                    <span
                      className="legend-color"
                      style={{
                        width: "20px",
                        height: "20px",
                        backgroundColor: REPORT_COLOR_ENCODING.DAMAGE,
                        borderRadius: "4px",
                        display: "inline-block",
                        marginRight: "8px",
                      }}
                    />
                    <span>Damage</span>
                  </div>
                  <div className="d-flex align-items-center">
                    <span
                      className="legend-color"
                      style={{
                        width: "20px",
                        height: "20px",
                        backgroundColor: REPORT_COLOR_ENCODING.EMERGENCY,
                        borderRadius: "4px",
                        display: "inline-block",
                        marginRight: "8px",
                      }}
                    />
                    <span>Emergency button pushed</span>
                  </div>
                </div>
              </div>
              {onLoader ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ minHeight: "400px" }}
                >
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <div className="table table-responsive custom-table">
                  <table className="table table-borderless">
                    <thead>
                      <tr>
                        <th>
                          {/* <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              defaultValue=""
                              id="checkAll"
                            />
                          </div> */}
                          Sr. no.
                        </th>
                        <th>Date</th>
                        <th>Time</th>
                        <th>Location</th>
                        <th>Cleaner Name</th>
                        <th>Depot Name</th>
                        <th>Bus Number</th>
                        <th>company</th>
                        <th>Desc of Work</th>
                        <th>cleaning type</th>
                        {/* <th>Issue Name</th> */}
                        {/* <th>Issue Images</th> */}
                        {/* <th></th> */}
                        {/* <th>Signature Cleaner</th> */}
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportData && reportData.length > 0 ? (
                        reportData.map((arr, i) => (
                          <tr className="red-color-report" key={arr?.id}>
                            <td>{++i + 10 * (pageNumber - 1)}</td>
                            <td>
                              <span className="text-warning">{arr?.date}</span>
                            </td>
                            <td>{arr?.time?.split(".")[0]}</td>
                            <td>{arr?.location}</td>
                            <td>{arr?.name_cleaner}</td>
                            <td>{arr?.depo?.depo_name}</td>
                            <td>{arr?.bus_number}</td>
                            <td>{arr?.company?.company_name}</td>
                            <td>{arr?.desc_of_work}</td>
                            {(() => {
                              const colorResult = getCleaningTypeColor(arr);
                              return (
                                <td
                                  className="text-center"
                                  style={{
                                    ...(Array.isArray(colorResult)
                                      ? getStripeStyle(colorResult)
                                      : {
                                          backgroundColor:
                                            colorResult || undefined,
                                        }),
                                    color: colorResult ? "#fff" : undefined,
                                  }}
                                >
                                  {(arr?.cleaning_type).replace("_", " ")}
                                </td>
                              );
                            })()}
                            <td>
                              <Link
                                className="btn btn-outline-info btn-sm rounded-circle btn-sm mx-1 "
                                to={`/report-view/${arr.id}`}
                                state={{ pageNumber, searchData }}
                              >
                                <i className="fa fa-eye" />
                              </Link>
                              {!(
                                loginUser?.user_type === "CLIENT" ||
                                loginUser?.user_type === "SUPER_ADMIN"
                              ) && (
                                <Link
                                  to="#"
                                  onClick={(e) => {
                                    if (
                                      loginUser?.user_type ===
                                      "CLEANING_MANAGER"
                                    ) {
                                      e.preventDefault();
                                    } else {
                                      deleteHandle(arr?.id);
                                    }
                                  }}
                                  className={`btn btn-outline-danger rounded-circle btn-sm ${
                                    loginUser?.user_type === "CLEANING_MANAGER"
                                      ? "disabled"
                                      : ""
                                  }`}
                                  style={
                                    loginUser?.user_type === "CLEANING_MANAGER"
                                      ? {
                                          pointerEvents: "none",
                                          opacity: 0.6,
                                          cursor: "not-allowed",
                                        }
                                      : {}
                                  }
                                >
                                  <i className="fa fa-trash" />
                                </Link>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="11">Data Not Found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  {/* <div>
                      <nav aria-label="Page navigation example">
                        <ul className="pagination">
                          <li className="page-item"  onClick={() => setPageNumber((prev) => prev - 1)}>
                            <Link className="page-link" to="#">
                              Previous
                            </Link>
                          </li>
                           <li className="page-item active">
                            <Link className="page-link" to="#">
                            {pageNumber}
                            </Link>
                          </li> 
                          <li className="page-item "  onClick={() => setPageNumber((prev) => prev + 2)}>
                            <Link className="page-link" to="#">
                             {pageNumber+1}
                            </Link>
                          </li>
                          <li className="page-item"  onClick={() => setPageNumber((prev) => prev + 2)}>
                            <Link className="page-link" to="#">
                           { pageNumber+2}
                            </Link>
                          </li>
                          <li className="page-item"  onClick={() => setPageNumber((prev) => prev + 1)}>
                            <Link className="page-link" to="#" >
                              Next
                            </Link>
                          </li>
                        </ul>
                      </nav>
                    </div> */}
                  {reportData && reportData.length > 0 && (
                    <Pagination
                      pageNumber={pageNumber}
                      setPageNumber={setPageNumber}
                      pageLimit={pageLimit}
                      paginationDetails={paginationDetails}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
